<template>
    <div class="user row" id="userHello">
        <div class="col-3">
            <div class="photo">
                <img :src="user.userPicture || 'static/img/faces/face-0.jpg'" alt="user avatar"/>
            </div>
        </div>
        <div class="col-9 user-info">
            <div class="info">
                <span class="user-options">
                    Pozdrav, {{user.name}}!
                </span>

              <!-- <a href="api/logout" @click="handleLogout" :title="$t( 'general.logout')">
                  <span class="sidebar-normal"><i class="fa fa-sign-out-alt"></i></span>
              </a> -->
              <div class="clearfix"></div>

            </div>
            <p v-if="user.title"><strong>{{user.title}}</strong></p><br>
            <p v-if="user.company" class="small text-uppercase">{{user.company}}</p>
        </div>
    </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'
  import config from 'src/config.js'

  export default {
    components: {
      CollapseTransition
    },
    data() {
      return {
        isClosed: true,
      }
    },
    computed: {
      user: function() { return this.$store.user.data || {} }
    },
    mounted() {
    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      },
      handleLogout() {
        this.$store.user.data = null;
      }
    }
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
  .photo {
    width: 90px;
  }
  .photo img {
      border-radius: 50%;
  }
  .user-options {
      font-size: 21px;
  }
  .user-info {
        padding-left: 45px;
  }
</style>
